module.exports = __webpack_public_path__ + "static/img/info-64px.1020a01f.png";